export default __webpack_public_path__ + "images/ac770f4cf20dfff682eb5e217a73c8b8-spirituality.webp";